/** Префикс system_key систем-проекта CRM «Отдел продаж». */
export const TASK_TRACKER_CRM_SALES_DEPARTMENT_SYSTEM_KEY_PREFIX =
  'crm.sales_department' as const

export const TASK_TRACKER_CRM_SALES_DEPARTMENT_PROJECT_HINT =
  'Этот «проект» нельзя удалить, он используется для простановки задач менеджерам по продажам в CRM-системе'

export const isTaskTrackerCrmSalesDepartmentProject = (
  systemKey: string | null | undefined,
): boolean =>
  String(systemKey ?? '')
    .trim()
    .startsWith(TASK_TRACKER_CRM_SALES_DEPARTMENT_SYSTEM_KEY_PREFIX)
